/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["to",[["HH","EA"],u,["hengihengi","efiafi"]],[["HH","EA"]],[["S","M","T","P","T","F","T"],["Sāp","Mōn","Tūs","Pul","Tuʻa","Fal","Tok"],["Sāpate","Mōnite","Tūsite","Pulelulu","Tuʻapulelulu","Falaite","Tokonaki"],["Sāp","Mōn","Tūs","Pul","Tuʻa","Fal","Tok"]],u,[["S","F","M","ʻE","M","S","S","ʻA","S","ʻO","N","T"],["Sān","Fēp","Maʻa","ʻEpe","Mē","Sun","Siu","ʻAok","Sēp","ʻOka","Nōv","Tīs"],["Sānuali","Fēpueli","Maʻasi","ʻEpeleli","Mē","Sune","Siulai","ʻAokosi","Sēpitema","ʻOkatopa","Nōvema","Tīsema"]],[["S","F","M","ʻE","M","S","S","ʻA","S","ʻO","N","T"],["Sān","Fēp","Maʻa","ʻEpe","Mē","Sun","Siu","ʻAok","Sēp","ʻOka","Nōv","Tīs"],["Sānuali","Fēpueli","Maʻasi","ʻEpeleli","Mē","Sune","Siulai","ʻAokosi","Sepitema","ʻOkatopa","Nōvema","Tīsema"]],[["KM","TS"],u,["ki muʻa","taʻu ʻo Sīsū"]],1,[6,0],["d/M/yy","d MMM y","d MMMM y","EEEE d MMMM y"],["h:mm a","h:mm:ss a","h:mm:ss a z","h:mm:ss a zzzz"],["{1} {0}","{1}, {0}",u,u],[".",",",";","%","+","-","E","×","‰","∞","TF",":"],["#,##0.###","#,##0%","¤ #,##0.00","#E0"],"TOP","T$","Paʻanga fakatonga",{"AUD":["AUD$","AU$"],"FJD":[u,"F$"],"JPY":["JP¥","¥"],"NZD":["NZD$","NZ$"],"SBD":[u,"S$"],"TOP":["T$"],"USD":["US$","$"]},"ltr", plural];
